import { FC } from 'react';
import ContractForm from '../components/ContractForm';
import { useNavigate } from 'react-router-dom';
import {
  createPostContractRequestFromFormData,
  useCreateContractMutation,
  useGetCollectionConstraintTypesQuery,
} from '../../../api/contractApi';
import { generateFormData } from '../generateFormData';
import HeaderLayout from '../../../components/HeaderLayout';
import { logger } from '../../../services/logger';
import { useGetWasteItemsQuery } from '../../../api/otherApi';
import { useGetDriverSkillLevelsQuery } from '../../../api/driverApi';
import { useGetCurrentUserQuery } from '../../../api/userApi';

const NewContract: FC = () => {
  const navigate = useNavigate();

  const { data: wasteItems } = useGetWasteItemsQuery();
  const { data: constraintTypes } = useGetCollectionConstraintTypesQuery();
  const { data: skillLevels } = useGetDriverSkillLevelsQuery();
  const { data: currentUser } = useGetCurrentUserQuery();
  const [create] = useCreateContractMutation();

  return (
    <HeaderLayout title="受注入力">
      <ContractForm
        initState={generateFormData({
          wasteItems,
          constraintTypes,
          skillLevels,
          currentUser,
        })}
        wasteItems={wasteItems}
        constraintTypes={constraintTypes}
        skillLevels={skillLevels}
        onSubmit={(data) => {
          create(createPostContractRequestFromFormData(data))
            .unwrap()
            .then(() => {
              navigate('/contracts');
            })
            .catch(logger.error);
        }}
        onCancel={() => {
          navigate('/contracts');
        }}
      />
    </HeaderLayout>
  );
};

export default NewContract;
